{
  "professionOptions": {
    "accountingBankingInsuranceFinance": {
      "title": "Contabilidad, banca, seguros y finanzas",
      "titles": {
        "accountant": "Contable",
        "actuary": "Actuario",
        "auditor": "Auditor",
        "bankAdministrator": "Administrador bancario",
        "bookkeeper": "Contable",
        "branchManager": "Gerente de sucursal",
        "chiefFinancialOfficer": "Director financiero",
        "claimsAdjuster": "Perito de siniestros",
        "clericalWorker": "Empleado administrativo",
        "commoditiesTrader": "Comerciante de materias primas",
        "complianceRiskAnalyst": "Analista de cumplimiento normativo/riesgos",
        "consultant": "Consultor",
        "controller": "Controlador",
        "creditAnalyst": "Analista de crédito",
        "creditManager": "Gerente de crédito",
        "customerServiceRepresentative": "Representante de atención al cliente",
        "economist": "Economista",
        "executiveSeniorManagementAccountingBankingInsuranceAndFinance": "Ejecutivo/Alta dirección",
        "financialAnalyst": "Analista financiero",
        "financialAdvisor": "Asesor financiero",
        "financialPlanner": "Planificador financiero",
        "insuranceAgent": "Agente de seguros",
        "insuranceBroker": "Corredor de seguros",
        "internalAuditor": "Auditor interno",
        "investmentAnalyst": "Analista de inversiones",
        "investmentBanker": "Banquero de inversión",
        "investmentConsultant": "Asesor de inversiones",
        "investmentFundManager": "Gestor de fondos de inversión",
        "investmentRepresentative": "Representante de inversiones",
        "loanOfficer": "Agente de préstamos",
        "managementConsultant": "Consultor de gestión",
        "manager": "Gerente",
        "mutualFundSalesRepresentative": "Representante de ventas de fondos de inversión",
        "portfolioManager": "Gestor de cartera",
        "productManager": "Gerente de producto",
        "securitiesTrader": "Operador de valores",
        "statistician": "Estadístico",
        "stockBroker": "Corredor de bolsa",
        "taxAssessmentAndCollectionsOfficer": "Funcionario de liquidación y recaudación de impuestos",
        "treasurer": "Tesorero",
        "underwriter": "Asegurador",
        "other": "Otros"
      }
    },
    "administrationAndHumanResources": {
      "title": "Administración y Recursos Humanos",
      "titles": {
        "administrativeAssistant": "Asistente administrativo",
        "clericalWorker": "Empleado administrativo",
        "consultant": "Consultor",
        "customerServiceRepresentative": "Representante de atención al cliente",
        "custodian": "Custodio",
        "executiveAssistant": "Asistente ejecutivo",
        "executiveSeniorManagementAdministrationAndHumanResources": "Ejecutivo/Alta dirección",
        "facilitiesSpecialist": "Especialista en instalaciones",
        "generalOfficeClerk": "Empleado administrativo general",
        "humanResourcesConsultant": "Consultor de Recursos Humanos",
        "humanResourcesSpecialist": "Especialista en Recursos Humanos",
        "inventoryControlClerk": "Empleado de control de inventario",
        "inventoryControlSpecialist": "Especialista en control de inventario",
        "manager": "Gerente",
        "mediator": "Mediador",
        "officeManager": "Gerente de oficina",
        "personalAssistant": "Asistente personal",
        "procurementOfficer": "Responsable de compras",
        "projectManager": "Gerente de proyectos",
        "purchasingAgent": "Agente de compras",
        "payrollBenefitsAdministrator": "Administrador de nóminas y prestaciones",
        "receptionist": "Recepcionista",
        "recruiter": "Reclutador",
        "recordsManagementTechnician": "Técnico en gestión de registros",
        "telephoneOperator": "Operador telefónico",
        "unionRepresentative": "Representante sindical",
        "other": "Otros"
      }
    },
    "agricultureAndNaturalResources": {
      "title": "Agricultura y recursos naturales",
      "titles": {
        "agriculturalWorker": "Trabajador agrícola",
        "agricultureAndNaturalResourcesSupportActivities": "Actividades de apoyo",
        "aquacultureWorker": "Trabajador acuícola",
        "breeder": "Criador",
        "conservationist": "Conservacionista",
        "customerServiceRepresentative": "Representante de atención al cliente",
        "dairyWorker": "Trabajador lechero",
        "drillingOilAndGas": "Perforación - Petróleo y gas",
        "executiveSeniorManagementAgricultureAndNaturalResources": "Ejecutivo/Alta dirección",
        "farmer": "Agricultor",
        "fisheriesWorker": "Trabajador pesquero",
        "florist": "Florista",
        "foodProducer": "Productor de alimentos",
        "forestryWorker": "Trabajador forestal",
        "grainElevatorOperator": "Operador de elevador de granos",
        "harvester": "Cosechador",
        "horticultureWorker": "Trabajador hortícola",
        "inspector": "Inspector",
        "livestockWorker": "Trabajador ganadero",
        "loggingWorker": "Trabajador forestal",
        "managerAgricultureAndNaturalResources": "Gerente, Agricultura y Recursos Naturales",
        "metalsProcessingWorker": "Trabajador de procesamiento de metales",
        "meteorologist": "Meteorólogo",
        "mineWorker": "Minero",
        "nurseryGreenhouseWorker": "Trabajador de vivero/invernadero",
        "oilIndustryWorker": "Trabajador de la industria petrolera",
        "pulpAndPaperProcessingWorker": "Trabajador de procesamiento de pulpa y papel",
        "quarryWorker": "Trabajador de cantera",
        "solarPowerWorker": "Trabajador de energía solar",
        "trapper": "Cazador",
        "undergroundWorker": "Trabajador subterráneo",
        "other": "Otros"
      }
    },
    "artsEntertainmentAndCommunications": {
      "title": "Artes, entretenimiento y comunicaciones",
      "titles": {
        "actorActress": "Actor/Actriz",
        "advertisingSpecialist": "Especialista en publicidad",
        "animator": "Animador",
        "announcerBroadcaster": "Locutor/Presentador",
        "antiqueDealer": "Anticuario",
        "artisanCrafter": "Artista/artesano",
        "artist": "Artista",
        "audioVisualTechnician": "Técnico audiovisual",
        "author": "Autor",
        "casinoCustomerService": "Servicio de atención al cliente del casino",
        "casinoDealer": "Croupier de casino",
        "casinoGamingManager": "Gerente de juegos de casino",
        "choreographer": "Coreógrafo",
        "communicationsSpecialist": "Especialista en comunicaciones",
        "composer": "Compositor",
        "conductor": "Conductor",
        "curator": "Curador",
        "dancer": "Bailarín",
        "designer": "Diseñador",
        "director": "Director",
        "editor": "Editor",
        "executiveSeniorManagementArtsEntertainmentAndCommunications": "Ejecutivo/Alta dirección",
        "filmVideoCameraOperator": "Operador de cámara de cine/vídeo",
        "graphicArtist": "Artista gráfico",
        "graphicDesigner": "Diseñador gráfico",
        "illustrator": "Ilustrador",
        "industrialDesigner": "Diseñador industrial",
        "instructor": "Instructor",
        "interiorDesignerDecorator": "Diseñador/decorador de interiores",
        "interpreter": "Intérprete",
        "journalist": "Periodista",
        "makeupArtist": "Maquillador",
        "managerArtsEntertainmentAndCommunications": "Gerente de Arte, Entretenimiento y Comunicaciones",
        "mediaRelations": "Relaciones con los medios",
        "model": "Modelo",
        "museumWorker": "Trabajador de museo",
        "musician": "Músico",
        "performingArtist": "Artista intérprete",
        "photographer": "Fotógrafo",
        "printer": "Empleado de imprenta",
        "producer": "Productor",
        "productionWorker": "Trabajador de producción",
        "proofreader": "Corrector",
        "publicRelationsWorker": "Trabajador de relaciones públicas",
        "publicist": "Publicista",
        "publisher": "Editor",
        "reporter": "Periodista",
        "researcher": "Investigador",
        "sculptor": "Escultor",
        "singer": "Cantante",
        "switchboardOperator": "Operador de centralita telefónica",
        "tattooArtist": "Artista del tatuaje",
        "theatreWorker": "Trabajador teatral",
        "translator": "Traductor",
        "writer": "Escritor",
        "other": "Otros"
      }
    },
    "educationAndTraining": {
      "title": "Educación y formación",
      "titles": {
        "caretakerJanitor": "Conserje/Encargado de mantenimiento",
        "childCareWorker": "Trabajador de cuidado infantil",
        "counsellor": "Consejero",
        "dean": "Decano",
        "earlyChildhoodEducator": "Educador de la primera infancia",
        "educationAndTrainingSupportActivities": "Actividades de apoyo a la educación y la formación",
        "educationalAssistant": "Asistente educativo",
        "employmentCounsellor": "Asesor laboral",
        "executiveSeniorManagement": "Ejecutivo/Alta dirección",
        "historian": "Historiador",
        "instructor": "Instructor",
        "librarian": "Bibliotecario",
        "lifeCoach": "Entrenador personal",
        "managerEducationAndTraining": "Gerente de Educación y Formación",
        "officeAdminSecretary": "Administrativo/Secretario de oficina",
        "professor": "Profesor",
        "researchAssistant": "Asistente de investigación",
        "researcher": "Investigador",
        "schoolBusDriver": "Conductor de autobús escolar",
        "schoolCounsellor": "Orientador escolar",
        "schoolPrincipal": "Director de escuela",
        "schoolCollegeAdministrator": "Administrador escolar/universitario",
        "superintendent": "Superintendente",
        "teacher": "Profesor",
        "teachingAssistant": "Asistente de enseñanza",
        "trainer": "Entrenador",
        "tutor": "Tutor/a",
        "vicePrincipal": "Subdirector",
        "other": "Otros"
      }
    },
    "engineeringArchitectureAndScience": {
      "title": "Ingeniería, Arquitectura y Ciencia",
      "titles": {
        "aerospaceEngineer": "Ingeniero aeroespacial",
        "architect": "Architecto",
        "astronomer": "Astrónomo",
        "biochemist": "Bioquímico",
        "bioEngineer": "Bioingeniero",
        "biologist": "Biólogo",
        "cADDraftingTechnician": "Técnico en CAD/Dibujo Técnico",
        "chemicalEngineer": "Ingeniero químico",
        "chemist": "Químico",
        "civilEngineer": "Ingeniero civil",
        "consultant": "Consultor",
        "electricalEngineer": "Ingeniero eléctrico",
        "electricalPowerAndCableWorker": "Trabajador de energía eléctrica y cables",
        "energyNuclearEngineer": "Ingeniero energético/nuclear",
        "executiveSeniorManagementEngineeringArchitectureAndScience": "Ejecutivo/Alta dirección",
        "geochemist": "Geoquímico",
        "geologist": "Geólogo",
        "industrialEngineer": "Ingeniero industrial",
        "inspector": "Inspector",
        "laboratoryTechnician": "Técnico de laboratorio",
        "managerEngineeringArchitectureAndScience": "Gerente de Ingeniería, Arquitectura y Ciencia",
        "manufacturingEngineer": "Ingeniero de fabricación",
        "marineEngineer": "Ingeniero naval",
        "mathematician": "Matemático",
        "mechanicalEngineer": "Ingeniero mecánico",
        "metallurgist": "Metalúrgico",
        "meteorologist": "Meteorólogo",
        "miningEngineer": "Ingeniero de minas",
        "nuclearPowerWorker": "Trabajador de energía nuclear",
        "petroleumEngineer": "Ingeniero petrolero",
        "physicist": "Físico",
        "powerSystemsEngineer": "Ingeniero de sistemas de energía",
        "professionalEngineer": "Ingeniero profesional",
        "projectManager": "Gerente de proyectos",
        "researcher": "Investigador",
        "scientist": "Científico",
        "sociologistAnthropologist": "Sociólogo/Antropólogo",
        "urbanPlanner": "Urbanista",
        "other": "Otros"
      }
    },
    "governmentDiplomaticAndProtectiveServices": {
      "title": "Servicios gubernamentales, diplomáticos y de protección",
      "titles": {
        "ambassadorAttacheOrCounsellorOfAnAmbassador": "Embajador, agregado o consejero de un embajador",
        "borderSecurityAgent": "Agente de seguridad fronteriza",
        "cityAdministrator": "Administrador municipal",
        "cityCounsellor": "Concejal municipal",
        "civilServant": "Funcionario público",
        "communityServicesWorker": "Trabajador de servicios comunitarios",
        "consultant": "Consultor",
        "correctionsOfficer": "Oficial de prisiones",
        "customsOfficer": "Funcionario de aduanas",
        "deputyMinister": "Viceministro",
        "diplomaticPersonnel": "Personal diplomático",
        "emergencyMedicalTechnician": "Técnico en emergencias médicas",
        "firefighter": "Bombero",
        "governmentAdministrator": "Administrador gubernamental",
        "governmentInspector": "Inspector del Gobierno",
        "governmentServicesOfficer": "Funcionario de servicios gubernamentales",
        "governmentDiplomaticAndProtectiveServicesSupportActivities": "Actividades de apoyo",
        "headOfGovernmentAgencyInstituteOrCharity": "Director de organismo gubernamental, instituto u organización benéfica",
        "indigenousCouncilMember": "Miembro del Consejo Indígena",
        "intelligenceAnalysisSpecialist": "Especialista en inteligencia/análisis",
        "mayor": "Alcalde",
        "memberOfGovernment": "Miembro del Gobierno",
        "paramedic": "Paramédico",
        "policeOfficer": "Agente de policía",
        "policyAnalyst": "Analista de políticas",
        "postalWorker": "Trabajador postal",
        "programOfficer": "Oficial de programas",
        "regulatoryOfficer": "Responsable de regulación",
        "schoolBoardTrustee": "Miembro del consejo escolar",
        "securityGuard": "Guardia de seguridad",
        "socialWorker": "Trabajador social",
        "urbanPlanner": "Urbanista",
        "wasteRemoval": "Eliminación de residuos",
        "other": "Otros"
      }
    },
    "hospitalityFoodAndTourism": {
      "title": "Hostelería, Alimentación y Turismo",
      "titles": {
        "baker": "Panadero",
        "bartender": "Camarero",
        "butcher": "Carnicero",
        "caterer": "Servicio de catering",
        "chef": "Chef",
        "cook": "Cocinero",
        "customerServiceRepresentative": "Representante de atención al cliente",
        "eventsPlanner": "Organizador de eventos",
        "executiveSeniorManagementHospitalityFoodAndTourism": "Ejecutivo/Alta dirección",
        "ferryWorker": "Trabajador del ferry",
        "foodServicesWorker": "Trabajador de servicios alimentarios",
        "hospitalityServicesWorker": "Trabajador de servicios de hostelería",
        "hostHostess": "Anfitrión/Anfitriona",
        "hotelStaff": "Personal del hotel",
        "housekeeper": "Camarera de piso",
        "kitchenStaff": "Personal de cocina",
        "manager": "Gerente",
        "pastryChef": "Pastelero",
        "restaurantManager": "Gerente de restaurante",
        "sousChef": "Segundo chef",
        "tourTravelGuide": "Guía turística/de viajes",
        "travelAgent": "Agente de viajes",
        "waiterServer": "Camarero/Camarera",
        "other": "Otros"
      }
    },
    "informationTechnology": {
      "title": "Tecnología de la información",
      "titles": {
        "computerConsultant": "Consultor informático",
        "computerEngineer": "Ingeniero informático",
        "dataCentreManager": "Gerente del centro de datos",
        "dataEntryClerk": "Empleado de entrada de datos",
        "electronics": "Electrónica",
        "executiveSeniorManagementInformationTechnology": "Ejecutivo/Alta dirección",
        "informationSystems": "Sistemas de información",
        "projectManager": "Gerente de proyectos",
        "specialist": "Especialista",
        "multimediaProgrammer": "Programador multimedia",
        "productSpecialist": "Especialista en productos",
        "softwareEngineer": "Ingeniero de software",
        "switchboardOperator": "Operador de centralita telefónica",
        "technicalSupportAgent": "Agente de soporte técnico",
        "telecommunicationsInstaller": "Instalador de telecomunicaciones",
        "telecommunicationsSpecialist": "Especialista en telecomunicaciones",
        "webDesigner": "Diseñador web",
        "productManager": "Gerente de producto",
        "techExecutive": "Ejecutivo técnico",
        "uIUXDesigner": "Diseñador UI/UX",
        "other": "Otros"
      }
    },
    "legalServices": {
      "title": "Servicios jurídicos",
      "titles": {
        "administrativeAssistant": "Asistente administrativo",
        "arbitrator": "Árbitro",
        "articlingStudent": "Estudiante en prácticas",
        "bailiff": "Alguacil",
        "byLawOfficer": "Responsable de estatutos",
        "courtOfficer": "Oficial judicial",
        "courtReporter": "Taquígrafo judicial",
        "judge": "Juez",
        "lawClerk": "Asistente jurídico",
        "lawyer": "Abogado",
        "legalSupportActivities": "Actividades de apoyo jurídico",
        "magistrateMaster": "Magistrada/Maestría",
        "notary": "Notario",
        "paralegal": "Asistente jurídico",
        "paroleOfficer": "Oficial de libertad condicional",
        "probationOfficer": "Agente de libertad condicional",
        "registrar": "Registrador",
        "other": "Otros"
      }
    },
    "medicalHealthAndCareGiving": {
      "title": "Salud médica y prestación de cuidados",
      "titles": {
        "acupuncturist": "Acupunturista",
        "audiologist": "Audiólogo",
        "cardiologist": "Cardiólogo",
        "chiropractor": "Quiropráctico",
        "counsellor": "Consejero",
        "coroner": "Forense",
        "dayCareWorker": "Trabajador de guardería",
        "dentalHygienist": "Higienista dental",
        "dentist": "Dentista",
        "dietitian": "Dietista",
        "dispatcher": "Operador",
        "doctor": "Doctor",
        "fosterParent": "Padre adoptivo",
        "funeralHomeWorker": "Empleado de funeraria",
        "healthCareCounsellor": "Asesor de atención médica",
        "homeCareWorker": "Cuidador a domicilio",
        "homeopath": "Homeópata",
        "hospitalAdministrator": "Administrador del hospital",
        "inspector": "Inspector",
        "laboratoryTechnician": "Técnico de laboratorio",
        "massageTherapist": "Masajista terapéutico",
        "medicalTechnician": "Técnico médico",
        "midwife": "Comadrona",
        "medicalImagingSpecialist": "Especialista en imágenes médicas",
        "mortician": "Funcionario de pompas fúnebres",
        "nanny": "Niñera",
        "naturopath": "Naturópata",
        "nurse": "Enfermera",
        "nutritionist": "Nutricionista",
        "occupationalTherapist": "Terapeuta ocupacional",
        "ophthalmologist": "Oftalmólogo",
        "optician": "Óptico",
        "optometrist": "Optometrista",
        "paramedic": "Paramédico",
        "pharmacyTechnician": "Técnico de farmacia",
        "pathologist": "Patólogo",
        "personalSupportWorker": "Asistente personal",
        "pharmacist": "Farmacéutico",
        "physiotherapist": "Fisioterapeuta",
        "podiatrist": "Podólogo",
        "psychologist": "Psicólogo",
        "Radiologist": "Radiólogo",
        "rehabilitationSpecialist": "Especialista en rehabilitación",
        "respiratoryTherapist": "Terapeuta respiratorio",
        "socialServicesWorker": "Trabajador social",
        "speechPathologist": "Logopeda",
        "surgeon": "Cirujano",
        "therapist": "Terapeuta",
        "veterinarian": "Veterinario",
        "veterinarianTechnician": "Técnico veterinario",
        "other": "Otros"
      }
    },
    "militaryServices": {
      "title": "Servicios militares",
      "titles": {
        "administrativeOfficer": "Oficial administrativo",
        "airTrafficController": "Controlador de tráfico aéreo",
        "aircraftTechnician": "Técnico aeronáutico",
        "artillerySpecialist": "Especialista en artillería",
        "chaplain": "Capellán",
        "combatMedicCorpsman": "Médico de combate/Sanitario",
        "combatSoldierInfantry": "Soldado de combate/Infantería",
        "constructionCombatEngineer": "Ingeniero de construcción/combate",
        "cookFoodServices": "Cocinero/Servicios de alimentos",
        "cyberWarfareSpecialist": "Especialista en guerra cibernética",
        "dentalTechnician": "Técnico dental",
        "electrician": "Electricista",
        "executiveSeniorManagement": "Ejecutivo/Alta dirección",
        "explosiveOrdnanceDisposalEod": "Desactivación de explosivos (EOD)",
        "financeSpecialist": "Especialista en finanzas",
        "firefighter": "Bombero",
        "intelligenceAnalyst": "Analista de inteligencia",
        "judgeAdvocateJag": "Juez Abogado (JAG)",
        "logisticsAndSupplyOfficer": "Oficial de logística y suministros",
        "mechanic": "Mecánico",
        "mentalHealthSpecialist": "Especialista en salud mental",
        "militaryPilot": "Piloto militar",
        "militaryPoliceOfficer": "Oficial de policía militar",
        "navalOfficer": "Oficial naval",
        "nurse": "Enfermera",
        "personnelSpecialist": "Especialista en personal",
        "publicAffairsSpecialist": "Especialista en asuntos públicos",
        "quartermaster": "Intendente",
        "recruiter": "Reclutador",
        "securityForceProtection": "Seguridad/Protección de la fuerza",
        "signalsCommunicationsSpecialist": "Especialista en señales/comunicaciones",
        "specialOperations": "Operaciones especiales",
        "submariner": "Submarinista",
        "supportActivities": "Actividades de apoyo",
        "surgeon": "Cirujano",
        "trainingInstructor": "Instructor de capacitación",
        "truckDriver": "Conductor de camión",
        "welder": "Soldador",
        "other": "Otros"
      }
    },
    "realEstateAndRelated": {
      "title": "Inmobiliaria y afines",
      "titles": {
        "appraiser": "Tasador",
        "homeBuilder": "Constructor de viviendas",
        "homeInspector": "Inspector de viviendas",
        "landDeveloper": "Promotor inmobiliario",
        "landSurveyor": "Topógrafo",
        "mortgageBroker": "Agente hipotecario",
        "propertyManager": "Administrador de propiedades",
        "propertyAssessor": "Tasador de propiedades",
        "realEstateAgent": "Agente inmobiliario",
        "renovator": "Renovador",
        "realEstateBroker": "Agente inmobiliario",
        "realEstateAssessor": "Tasador inmobiliario",
        "other": "Otros"
      }
    },
    "religiousVocation": {
      "title": "Vocación religiosa",
      "titles": {
        "chaplain": "Capellán",
        "clergyman": "Clérigo",
        "deacon": "Diácono",
        "imam": "Imán",
        "minister": "Ministro",
        "missionary": "Misionero",
        "monk": "Monje",
        "monsignor": "Monseñor",
        "nun": "Monja",
        "priest": "Sacerdote",
        "rabbi": "Rabino",
        "religiousWorker": "Trabajador religioso",
        "other": "Otros"
      }
    },
    "salesRepairAndRetailService": {
      "title": "Ventas, reparaciones y servicio minorista",
      "titles": {
        "animalCareWorker": "Trabajador de cuidado animal",
        "animalTrainer": "Entrenador de animales",
        "applianceRepairTechnician": "Técnico de reparación de electrodomésticos",
        "auctioneer": "Subastador",
        "automotiveRepair": "Reparación de automóviles",
        "automotiveSales": "Ventas de automóviles",
        "barber": "Barbero",
        "buyer": "Comprador",
        "callCentreRepresentative": "Representante de centro de llamadas",
        "cashier": "Cajero",
        "cleaningServiceProvider": "Proveedor de servicios de limpieza",
        "cosmetologist": "Cosmetólogo",
        "customerServiceRepresentative": "Representante de atención al cliente",
        "dryCleaner": "Tintorería",
        "electrologist": "Electróloga",
        "esthetician": "Esteticista",
        "executiveSeniorManagementSalesRepairAndRetailService": "Ejecutivo/Alta dirección",
        "exterminatorPestControl": "Exterminador/Control de plagas",
        "franchiseBusinessOwner": "Franquicia - Propietario de negocio",
        "hairdresser": "Peluquero",
        "importerExporter": "Importador/Exportador",
        "installer": "Instalador",
        "jeweler": "Joyero",
        "managerSalesRepairAndRetailService": "Gerente de Ventas, Reparaciones y Servicio Minorista",
        "marketingRepresentative": "Representante de marketing",
        "merchandiser": "Comerciante",
        "retailWorker": "Trabajador minorista",
        "salesAndRetailSupportWorker": "Empleado de ventas y asistencia al cliente",
        "salesperson": "Vendedor",
        "seamstressTailor": "Costurera/Sastre",
        "serviceStationAttendant": "Empleado de estación de servicio",
        "shoeRepairMaker": "Reparación/Fabricación de calzado",
        "smallEngineTechnician": "Técnico de motores pequeños",
        "spaServiceProvider": "Proveedor de servicios de spa",
        "storeManager": "Gerente de tienda",
        "telemarketer": "Operador de telemarketing",
        "televisionTechnician": "Técnico de televisión",
        "upholsterer": "Tapicero",
        "visualDisplayMerchandisingSpecialist": "Especialista en vitrinas y mercadotechnia visual",
        "windowWasher": "Limpiador de ventanas",
        "other": "Otros"
      }
    },
    "sportsAndLeisure": {
      "title": "Deportes y ocio",
      "titles": {
        "amusementParkWorker": "Trabajador de parque de atracciones",
        "coach": "Entrenador",
        "lifeguard": "Socorrista",
        "personalServicesWorker": "Trabajador de servicios personales",
        "personalTrainer": "Entrenador personal",
        "professionalAthlete": "Atleta profesional",
        "recreationalGuide": "Guía recreativa",
        "sportsAgent": "Agente deportivo",
        "sportsInstructor": "Instructor deportivo",
        "sportsManager": "Gerente deportivo",
        "sportsOfficial": "Oficial deportivo",
        "sportsTherapist": "Terapeuta deportivo",
        "other": "Otros"
      }
    },
    "tradesConstructionAndManufacturing": {
      "title": "Comercio, construcción y manufactura",
      "titles": {
        "apprentice": "Aprendiz",
        "assemblyWorker": "Trabajador de montaje",
        "blacksmith": "Herrero",
        "boilermaker": "Calderero",
        "bricklayer": "Albañil",
        "builder": "Constructor",
        "cabinetMaker": "Ebanista",
        "carpenter": "Carpintero",
        "concreteWorker": "Trabajador del hormigón",
        "constructionWorker": "Obrero de la construcción",
        "craneOperator": "Operador de grúa",
        "cutter": "Cortador",
        "developer": "Desarrollador",
        "draftingDesign": "Redacción/Diseño",
        "driller": "Perforador",
        "drywaller": "Enlucidor",
        "electrician": "Electricista",
        "elevator Technician": "Técnico de ascensores",
        "engineer": "Ingeniero",
        "executiveSeniorManagementTradesConstructionAndManufacturing": "Ejecutivo/Alta dirección",
        "fabricator": "Fabricante",
        "factoryWorker": "Trabajador de fábrica",
        "finisher": "Trabajador de acabados",
        "forkliftOperator": "Operador de carretilla elevadora",
        "foundryWorker": "Trabajador de fundición",
        "framer": "Enmarcador",
        "gasFitter": "Instalador de gas",
        "generalContractor": "Contratista general",
        "glassFormerFinisher": "Formador/Acabador de vidrio",
        "heavyDutyMechanic": "Mecánico de maquinaria pesada",
        "heavyEquipmentOperator": "Operador de maquinaria pesada",
        "hVACInstaller": "Instalador de sistemas de climatización",
        "inspector": "Inspector",
        "installer": "Instalador",
        "ironworker": "Herrero",
        "labourer": "Obrero",
        "landscaper": "Paisajista",
        "locksmith": "Cerrajero",
        "machineFitter": "Montador de máquinas",
        "machineOperator": "Operador de máquina",
        "manager": "Gerente",
        "manufacturingWorker": "Trabajador de fabricación",
        "mechanic": "Mecánico",
        "metalWorker": "Trabajador metalúrgico",
        "millwright": "Mecánico industrial",
        "oilPipelineWorker": "Trabajador petrolero/de oleoductos",
        "painter": "Pintor",
        "paver": "Alicatador",
        "pipefitter": "Instalador de tuberías",
        "plasterer": "Yesero",
        "plumber": "Fontanero",
        "purchasingManager": "Gerente de compras",
        "qualityAssuranceAnalyst": "Analista de control de calidad",
        "recycler": "Reciclador",
        "renovator": "Renovador",
        "roofer": "Techador",
        "sheetMetalWorker": "Trabajador metalúrgico",
        "skilledLabourer": "Trabajador cualificado",
        "steamfitter": "Instalador de tuberías de vapor",
        "surveyor": "Topógrafo",
        "textileWorker": "Trabajador textil",
        "tileSetter": "Colocador de baldosas",
        "toolAndDieMaker": "Fabricante de herramientas y matrices",
        "tradesperson": "Comerciante",
        "welder": "Soldador",
        "weaver": "Tejedor",
        "woodworker": "Carpintero",
        "other": "Otros"
      }
    },
    "transportationAndUtilities": {
      "title": "Transporte y servicios públicos",
      "titles": {
        "airTrafficController": "Controlador de tráfico aéreo",
        "aircraftTechnician": "Técnico aeronáutico",
        "airlineAgent": "Agente de aerolínea",
        "baggageHandler": "Manipulador de equipaje",
        "busDriver": "Conductor de autobús",
        "cargoWorker": "Trabajador de carga",
        "conductor": "Conductor",
        "courierDelivery": "Mensajería/Entrega",
        "customsInspection": "Inspección aduanera",
        "deliveryDriver": "Repartidor",
        "dockWorker": "Trabajador portuario",
        "drillerBlaster": "Perforador/Volador",
        "executiveSeniorManagementTransportationAndUtilities": "Ejecutivo/Alta dirección",
        "ferryWorker": "Trabajador del ferry",
        "flightAttendant": "Azafata",
        "flightInstructor": "Instructor de vuelo",
        "heatingServiceProvider": "Proveedor de servicios de calefacción",
        "inspector": "Inspector",
        "janitor": "Conserje",
        "limoDriverChauffeur": "Conductor de limusina/chofer",
        "logisticsAnalyst": "Analista de logística",
        "mover": "Mudanza",
        "oilHeating": "Calefacción de aceite",
        "pilot": "Piloto",
        "publicWorksMaintenance": "Mantenimiento de obras públicas",
        "railwayMarineTransportWorker": "Trabajador ferroviario/marítimo",
        "shipmentBroker": "Agente de transporte",
        "shipperReceiver": "Remitente/Destinatario",
        "taxiDriver": "Taxi/Conductor",
        "transportationAndUtilitiesSupportActivities": "Actividades de apoyo al transporte y los servicios públicos",
        "truckDriver": "Conductor de camión",
        "utilityWorker": "Trabajador de servicios públicos",
        "wellDrillersOperators": "Perforadores/operadores de pozos",
        "wellSiteSupervisor": "Supervisor de obra",
        "waterTreatmentTechnician": "Técnico en tratamiento de aguas",
        "other": "Otros"
      }
    }
  },
  "areasOfStudy": {
    "aeronauticsAndAviationScience": "Ciencia aeronáutica y de la aviación",
    "anthropology": "Antropología",
    "art": "Arte",
    "businessAdministration": "Administración de Empresas",
    "chemistry": "Química",
    "economics": "Economía",
    "education": "Educación",
    "engineering": "Ingeniería",
    "environmentalScienceAndHealth": "Ciencias ambientales y salud",
    "journalismAndMassCommunication": "Periodismo y Comunicación de Masas",
    "music": "Música",
    "nursing": "Enfermería",
    "oceanography": "Oceanografía",
    "pharmacy": "Farmacia",
    "photography": "Fotografía",
    "physicalTherapy": "Fisioterapia",
    "politicalScienceAndInternationalRelations": "Ciencias Políticas y Relaciones Internacionales",
    "psychology": "Psicología",
    "publicRelationsAndAdministration": "Relaciones públicas y administración",
    "statistics": "Estadísticas",
    "urbanPlanning": "Planificación urbana"
  },
  "previousCompanyType": "Anterior {{companyType}}",
  "previousJobTitle": "Anterior {{jobTitle}}",
  "previousEmployerName": "Anterior {{employerName}}"
}
